import React, { useRef } from "react";
import { useOptimizedSrc } from "../hooks";
import { focalPointToOffset } from "../utils/focalPoint";
import { useResizeDetector } from "react-resize-detector";
import styled from "styled-components";
import { FocalPoint } from "../types";
const ContentstackImg = React.forwardRef(({ image, pixelRatio, optimized, crop, fit, quality = 90, focalPoint, ...imgProps }, ref) => {
    const { dimensions, dimension, accessibilityText, url } = image;
    const desiredFocalPoint = focalPoint || image.focalPoint || FocalPoint.CENTER;
    const targetRef = useRef(ref);
    const { width, height, ref: resizeRef } = useResizeDetector({ targetRef });
    const containerDimensions = { width: width || 0, height: height || 0 };
    const { offsetX, offsetY } = focalPointToOffset(desiredFocalPoint);
    if (!url) {
        throw new Error("Image url is required");
    }
    const optimizedSrc = useOptimizedSrc({
        imageDimensions: dimensions || dimension,
        containerDimensions,
        quality,
        crop,
        pixelRatio,
        offsetX,
        offsetY,
        fit,
        url,
    });
    const src = optimized ? optimizedSrc : url;
    return (React.createElement("img", { ref: resizeRef, src: src, className: imgProps.className, alt: accessibilityText || " ", ...imgProps }));
});
ContentstackImg.displayName = "ContentstackImg";
export default styled(ContentstackImg) `
  object-position: center;
`;
//# sourceMappingURL=ContentstackImg.js.map